var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedicalBox(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "medical_services_black_24dp_1_",
    "data-name": "medical_services_black_24dp (1)",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2190",
    "data-name": "Group 2190"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3414",
    "data-name": "Rectangle 3414",
    width: 20,
    height: 20,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2192",
    "data-name": "Group 2192",
    transform: "translate(1.667 1.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2191",
    "data-name": "Group 2191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8380",
    "data-name": "Path 8380",
    d: "M17,5.333H13.667V3.667A1.672,1.672,0,0,0,12,2H8.667A1.672,1.672,0,0,0,7,3.667V5.333H3.667A1.672,1.672,0,0,0,2,7V17a1.672,1.672,0,0,0,1.667,1.667H17A1.672,1.672,0,0,0,18.667,17V7A1.672,1.672,0,0,0,17,5.333ZM8.667,3.667H12V5.333H8.667Zm5,9.167h-2.5v2.5H9.5v-2.5H7V11.167H9.5v-2.5h1.667v2.5h2.5Z",
    transform: "translate(-2 -2)",
    fill: "#f8f9ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalBox);
export default __webpack_public_path__ + "static/media/medical_box.61fef80e6151d1a9d4f040b5b0441fa3.svg";
export { ForwardRef as ReactComponent };